export default "__VITE_ASSET__BBeWTiQe__"